import React from 'react';
import { useTranslation } from '../../i18n';
import { formatMoney } from '../../utils/format';

export function FleetSummaryTiles({ vehicles, activeVehicles, totalValue, brokenVehicles }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3 text-center">
        <p className="text-xs text-slate-500">{t('total_vehicles')}</p>
        <p className="text-xl font-bold text-foreground">{vehicles.length}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3 text-center">
        <p className="text-xs text-slate-500">{t('on_mission')}</p>
        <p className="text-xl font-bold text-money">{activeVehicles}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3 text-center">
        <p className="text-xs text-slate-500">{t('fleet_value')}</p>
        <p className="text-xl font-bold text-foreground">{formatMoney(totalValue)}</p>
      </div>
      <div className="bg-ink-800 rounded-lg border border-ink-600 p-3 text-center">
        <p className="text-xs text-slate-500">{t('broken_count')}</p>
        <p className={`text-xl font-bold ${brokenVehicles > 0 ? 'text-danger' : 'text-slate-500'}`}>{brokenVehicles}</p>
      </div>
    </div>
  );
}
